function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94,-4.604671964794049e-16,4.604671964794049e-16,0.94,15.36004971466727,15.360056991577267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m201.302 49.754-192 24.939A10.667 10.667 0 0 0 0 85.36v149.333c0 5.891 4.776 10.667 10.667 10.667h192c5.891 0 10.667-4.776 10.667-10.667V60.314a10.666 10.666 0 0 0-3.627-8 10.906 10.906 0 0 0-8.405-2.56z",
    style: {},
    fill: "#f44336",
    "data-original": "#f44336",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.374 13.36a10.665 10.665 0 0 0-8.405-2.667l-256 33.387a10.666 10.666 0 0 0-9.301 10.667v179.947c0 5.891 4.776 10.667 10.667 10.667h256c5.891 0 10.667-4.776 10.667-10.667V21.36a10.674 10.674 0 0 0-3.628-8z",
    style: {},
    fill: "#4caf50",
    "data-original": "#4caf50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.667 266.693h-192C4.776 266.693 0 271.469 0 277.36v149.333a10.667 10.667 0 0 0 9.301 10.667l192 25.045c.455.031.911.031 1.365 0 5.891 0 10.667-4.776 10.667-10.667V277.36c.001-5.891-4.775-10.667-10.666-10.667z",
    style: {},
    fill: "#2196f3",
    "data-original": "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.334 266.693h-256c-5.891 0-10.667 4.776-10.667 10.667v179.947a10.667 10.667 0 0 0 9.301 10.667l256 33.387c.455.031.911.031 1.365 0 5.891 0 10.667-4.776 10.667-10.667V277.36c0-5.891-4.775-10.667-10.666-10.667z",
    style: {},
    fill: "#ffc107",
    "data-original": "#ffc107",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/outlook-logo.a1e128c4fca53950dcb633816d6a362d.svg";
export { ForwardRef as ReactComponent };